/**
 * Created by Alex Aguilar on 7/28/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('sidebarMenuService', ['$http', 'CONFIG', function($http, CONFIG){

            var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/menus';

            return {
                getMenus: function(){
                    return $http.get(urlBase)
                }
            };
        }]);

})();
